// removed by extract-text-webpack-plugin
module.exports = {"controlPanelContainer":"Controls__controlPanelContainer___3-4IH","controlPanelForm":"Controls__controlPanelForm___Os2ef","inputGroup":"Controls__inputGroup___2ZmZr","formGroup":"Controls__formGroup___Sz1aH","formLabel":"Controls__formLabel___2llHN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Controls/Controls.scss
// module id = 194
// module chunks = 0